import { toLower } from 'lodash'

const normalize = (text = '') => toLower(text)

export const filterTextByFields = ({ fields = [], obj = {}, searchText = '' }) => {
  return fields.some((key) => normalize(obj[key]).includes(normalize(searchText)))
}
